import { Injectable } from '@angular/core';
import { AbstractGs } from 'projects/game-utils/src/lib/service/AbstractGs';

@Injectable({
  providedIn: 'root'
})
export class WarcabyGameService extends AbstractGs {

  constructor() { 
    super();
  }


  public createNewGame(rules:string, type:string):void {

  }

  public getGameRulesString():string {
    if (this.getGameRules() == "POLISH")
    {
      return  "Polish";
    }
    if (this.getGameRules() == "POLISH_100")
    {
      return  "International";
    }
    if (this.getGameRules() == "US")
    {
      return  "English";
    }
  }

  public getShortcut(rules:string):string{
    if (this.getGameRules() == "POLISH")
    {
      return  "Polish";
    }
    if (this.getGameRules() == "POLISH_100")
    {
      return  "International";
    }
    if (this.getGameRules() == "US")
    {
      return  "English";
    }
  }
}
